// 9fbef606107a605d69c0edbcd8029e5d 
export default {
  gridBreakPointsKeys: ['small', 'medium', 'large'],
  numberOfColumnsObj: {
    small: 6,
    medium: 8,
    large: 12,
  },
  columnWidthObj: {
    small: 42,
    medium: 66,
    large: 63,
  },
  columnGutterObj: {
    small: 19,
    medium: 30,
    large: 22,
  },
  gridOffsetObj: {
    small: 14,
    medium: 15,
    large: 13,
  },
  availableMaxWidthObj: {
    small: 347,
    medium: 740,
    large: 998,
  },
};
